import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import {
  FormGroup,
} from 'reactstrap';
import {
  capitalizeEveryWord,
  DEMO_FILTER_CATEGORY,
  DEMO_FILTER_DATA,
  GRAPH_CONST_VALUES,
} from '../../utils';
import DemoModal from './demoModal';


function AudienceDemographics(props) {
  const {
    isOpen, onClose, filterByDemographics, lastFilteredData, clearDemoFilter,
  } = props;

  const [modal, setModal] = useState(isOpen);
  const [ethnicity, setEthnicity] = useState(DEMO_FILTER_DATA.ethnicity);
  const [gender, setGender] = useState(DEMO_FILTER_DATA.gender);
  const [ageRange, setAgeRange] = useState(DEMO_FILTER_DATA.ageRange);
  const [country, setCountry] = useState();
  const [facebook, setFbFollowers] = useState('');
  const [instagram, setInstaFollowers] = useState('');
  const [twitter, setTwitterFollowers] = useState('');
  const [youtube, setYouTubeFollowers] = useState('');
  const [spotify, setSpotifyFollowers] = useState('');
  const [isDisabled, setDisabled] = useState(false);
  const [isCleared, setClearFilter] = useState(false);

  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  const hideModal = () => {
    toggle();
    props.onClose();
  };

  useEffect(() => {
    if (lastFilteredData.followers) {
      const data = lastFilteredData.followers;
      setFbFollowers(data.facebook);
      setInstaFollowers(data.instagram);
      setTwitterFollowers(data.twitter);
      setYouTubeFollowers(data.youtube);
      setSpotifyFollowers(data.spotify);
    }
    if (lastFilteredData.country) {
      setCountry(lastFilteredData.country);
    }
  }, [lastFilteredData]);

  const isCheckedData = (data) => {
    const result = [];
    map(data, (ele) => {
      if (ele.isChecked) {
        result.push(ele);
      }
    });
    return result;
  };

  /* function to set the followers object data including
     facebook, instagram, twitter, youtube, spotify */
  const setFollowersObject = () => {
    const followers = {};
    if (Number(facebook)) {
      followers.facebook = Number(facebook);
    }
    if (Number(instagram)) {
      followers.instagram = Number(instagram);
    }
    if (Number(twitter)) {
      followers.twitter = Number(twitter);
    }
    if (Number(youtube)) {
      followers.youtube = Number(youtube);
    }
    if (Number(spotify)) {
      followers.spotify = Number(spotify);
    }
    return followers;
  };

  const finalFilteredData = () => {
    const filterData = {};
    if (isCheckedData(ethnicity).length > 0) {
      filterData.ethnicity = ethnicity;
    }
    if (isCheckedData(gender).length > 0) {
      filterData.gender = gender;
    }
    if (isCheckedData(ageRange).length > 0) {
      filterData.ageRange = ageRange;
    }
    filterData.country = country;
    filterData.followers = setFollowersObject();
    return filterData;
  };

  const applyFilter = () => {
    if (!isCleared) {
      filterByDemographics(finalFilteredData(), true);
      onClose();
    }
    return null;
  };

  /* function to set the checked data of ethnicty, age and gender */
  const checkedDataResult = (data, item, checked) => {
    return map(data, (ele) => {
      if (ele._id === item._id) {
        ele.isChecked = checked;
      }
      return ele;
    });
  };

  const selectCategory = useCallback((event, item, type) => {
    setClearFilter(false);
    switch (type) {
      case DEMO_FILTER_CATEGORY.ETHNICITY:
        setEthnicity(checkedDataResult(DEMO_FILTER_DATA.ethnicity, item, event.target.checked));
        break;
      case DEMO_FILTER_CATEGORY.GENDER:
        setGender(checkedDataResult(DEMO_FILTER_DATA.gender, item, event.target.checked));
        break;
      case DEMO_FILTER_CATEGORY.AGE:
        setAgeRange(checkedDataResult(DEMO_FILTER_DATA.ageRange, item, event.target.checked));
        break;
      default:
        break;
    }
  });

  const fieldsLabels = (itemName) => {
    let label = '';
    if (itemName === GRAPH_CONST_VALUES.ETHNICITY_VALUE.AMERICAN) {
      label = capitalizeEveryWord(GRAPH_CONST_VALUES.ETHNICITY_LABEL.AMERICAN);
    } else if (itemName === GRAPH_CONST_VALUES.ETHNICITY_VALUE.WHITE) {
      label = capitalizeEveryWord(GRAPH_CONST_VALUES.ETHNICITY_LABEL.WHITE);
    } else if (DEMO_FILTER_DATA.AGE_VALUE[itemName]) {
      label = DEMO_FILTER_DATA.AGE_VALUE[itemName];
    } else {
      label = capitalizeEveryWord(itemName);
    }
    return label;
  };

  const renderListing = useCallback((data, filterType) => map(data, (item, index) => item && (
    <FormGroup key={`category-${index}`} className="input-field demographic-input">
      <label htmlFor={`category-${item.name}`} className="input-container-green">
        <input
          id={`category-${item.name}`}
          type="checkbox"
          onClick={(event) => selectCategory(event, item, filterType)}
          checked={item.isChecked}
        />
        {fieldsLabels(item.name)}
        <span className="checkmark" />
      </label>
    </FormGroup>
  )));

  const setFollowersData = (type, event) => {
    switch (type) {
      case 'facebook':
        setFbFollowers(event.target.value);
        break;
      case 'instagram':
        setInstaFollowers(event.target.value);
        break;
      case 'twitter':
        setTwitterFollowers(event.target.value);
        break;
      case 'spotify':
        setSpotifyFollowers(event.target.value);
        break;
      case 'youtube':
        setYouTubeFollowers(event.target.value);
        break;
      default:
        break;
    }
    setClearFilter(false);
  };

  const handleCountryChange = (selectedOption) => {
    setCountry(selectedOption);
    setClearFilter(false);
  };

  const clearCheckedFields = (item) => map(item, (ele) => {
    ele.isChecked = false;
    return ele;
  });

  const clearFilter = () => {
    setEthnicity(clearCheckedFields(ethnicity));
    setGender(clearCheckedFields(gender));
    setAgeRange(clearCheckedFields(ageRange));
    setFbFollowers('');
    setInstaFollowers('');
    setYouTubeFollowers('');
    setSpotifyFollowers('');
    setTwitterFollowers('');
    setCountry([]);
    setClearFilter(true);
    clearDemoFilter();
  };

  useEffect(() => {
    if ((!facebook && !instagram && !twitter && !spotify && !youtube)
    && ((country && Object.keys(country).length === 0) || !country)
    && (!isCheckedData(ethnicity).length && !isCheckedData(gender).length && !isCheckedData(ageRange).length)) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [ethnicity, country, gender, facebook, instagram, twitter, spotify, youtube, ageRange]);

  return (
    <DemoModal
      modal={modal}
      hideModal={hideModal}
      facebook={facebook}
      instagram={instagram}
      twitter={twitter}
      youtube={youtube}
      spotify={spotify}
      setFollowersData={setFollowersData}
      renderListing={renderListing}
      handleCountryChange={handleCountryChange}
      country={country}
      clearFilter={clearFilter}
      applyFilter={applyFilter}
      isDisabled={isDisabled}
    />
  );
}
AudienceDemographics.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  filterByDemographics: PropTypes.func.isRequired,
  lastFilteredData: PropTypes.object.isRequired,
  clearDemoFilter: PropTypes.func.isRequired,
};

export default AudienceDemographics;
